import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircle1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "check-circle-1" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M6,13.223,8.45,16.7a1.049,1.049,0,0,0,1.707.051L18,6.828",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 11.999,
			r: 11.25,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		})
	]
});
export { SvgCheckCircle1 as ReactComponent };
